import React, { Component } from "react";
import Detail from "./view/Detail.js";
import List from "./view/List.js";
import ViewModel from "./controllers/ViewModel.js";
import SubHeader from "../header/SubHeaderView.js";
import ExcelList from "./view/Excel.js";

export default class CorridasAgendadas extends Component {
  constructor(props) {
    super(props);
    this.viewModel = new ViewModel();
    this.viewModel.mirrorState = (s) => this.setState(s);
    this.viewModel.props = props;
  }

  componentDidMount() {
    console.log("CorridasAgendadas componentDidMount", this.props.childProps.user);

    this.viewModel.fetchData(this.props.childProps.user);
  }

  render() {
    return (
      <div className="page-content-wrapper">
        <SubHeader
          textoEsquerda="Corridas Agendadas"
          textoCentral="Corridas"
        />
        <div className="page-content">
          <div className="container">
            {this.viewModel.state.showModal && (
              <Detail {...this.props} viewModel={this.viewModel} />
            )}
            <List {...this.props} viewModel={this.viewModel} />
            <ExcelList {...this.props} file={"corridas_agendadas"} viewModel={this.viewModel} title="Corridas Agendadas" configs={[
              { label: "No.", value: "t12_num_corrida" },
              { label: "Data Agendamento", value: "t12_dthr_agendamento" },
              { label: "Data Corrida", value: "t12_dthr_corrida" },
              { label: "Passageiro", value: "t12_nome" },
              { label: "Endereço", value: "t12_endereco" },
              { label: "Valor", value: "valorcalculado" },
              { label: "Status", value: "ztatus3" },
              { label: "Centro de custo", value: "voucher_departamento_identificacao" },
              { label: "Descrição", value: "voucher_departamento_descricao" },
            ]} />
          </div>
        </div>
      </div>
    );
  }
}
